var render = function render(){var _vm=this,_c=_vm._self._c;return _c('OptionsForm',{ref:"form",attrs:{"fields":_vm.fields},on:{"submit":_vm.onSubmit},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }